import styled from 'styled-components';
export const ButtonRow = styled.div`
  align-items: center;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 14px;
`;